import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AcademicAttendanceReportService } from '@app/core';
import { notNull, safeEmptyList } from '@app/shared/utils';
import { AppSelectors } from '@app/store';
import { AppState } from '@app/store/app.state';
import { Store } from '@ngrx/store';
import { isEmpty } from 'lodash';

@Component({
  selector: 'app-card-academic-service-report',
  templateUrl: './card-academic-service-report.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CardAcademicServiceReportComponent implements OnInit {
  private readonly _academicAttendanceReportService = inject(AcademicAttendanceReportService);
  private readonly _store = inject<Store<AppState>>(Store);
  private readonly destroyRef = inject(DestroyRef);
  public page = 1;
  public user_id: number;
  public throttle = 300;
  public scrollDistance = 1;
  public scrollUpDistance = 2;
  public next_page_url: string;
  public previousReports = signal([]);
  public nextReports = signal([]);

  public ngOnInit(): void {
    this._store
      .select(AppSelectors.appFeature)
      .pipe(notNull())
      .subscribe(({ usuario_id }) => {
        this.user_id = usuario_id;
        this.loadPreviousReport();
        this.loadNextReport();
      });
  }

  public onScrollDown() {
    if (!!this.next_page_url) {
      this.loadPreviousReport((this.page += 1));
    }
  }

  public get hasFutureReports(): boolean {
    return !isEmpty(this.nextReports());
  }

  public get hasPastReports(): boolean {
    return !isEmpty(this.previousReports());
  }

  private loadPreviousReport(page?: number) {
    this._academicAttendanceReportService
      .dashboardPreviousReports({ user_id: this.user_id, page })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((res: any) => {
        this.next_page_url = res.data.next_page_url;
        this.previousReports.update((current) => [...current, ...res.data.data]);
      });
  }

  private loadNextReport() {
    this._academicAttendanceReportService
      .dashboardNextReports({ user_id: this.user_id })
      .pipe(takeUntilDestroyed(this.destroyRef), safeEmptyList())
      .subscribe((res) => this.nextReports.set(res));
  }
}
